import { render, staticRenderFns } from "./StatisticsFilterComparision.vue?vue&type=template&id=19d475ed"
import script from "./StatisticsFilterComparision.vue?vue&type=script&lang=js"
export * from "./StatisticsFilterComparision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports